import { add, listen, qs, qsa, remove, toggle } from '@fluorescent/dom';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { lock } from 'lbx';

const selectors = {
  collection: '[data-collection]',
  image: '[data-image]',
  overlay: '[data-overlay]',
  trigger: '[data-trigger]',
  submenu: '[data-submenu]',
};

export default function MegaNav(node) {
  const image = qs(selectors.image, node);
  const parents = qsa(selectors.trigger, node);
  const submenus = qsa(selectors.submenu, node);
  const collections = qsa(selectors.collection, node);

  const images = qsa('.image', node);
  const defaultImage = qs('.image--mega-nav-image', node);

  const showImages = Boolean(node.dataset.showImages);

  let imageOpen = showImages;
  let lockbox;

  const events = [
    // Click on the overlay and close mega nav
    listen(qs(selectors.overlay, node), 'click', close),

    // Click on a parent item and show child nav
    listen(parents, 'click', e => {
      e.preventDefault();
      const { trigger: triggerId } = e.currentTarget.dataset;

      // Hide the image
      if (showImages) {
        remove(image, 'visible');
        remove(defaultImage, 'active');
        imageOpen = false;
      }

      submenus.forEach(menu => {
        const { submenu: id } = menu.dataset;
        toggle(menu, 'visible', id === triggerId);
        menu.toggleAttribute('hidden', id !== triggerId);


        if (id === triggerId) {
          // console.log("shoudl focus", qs('a', menu))
          qs('a', menu).focus();
        }
      });
    }),

    // Show image when hovering over some link items
    showImages &&
      listen(collections, 'mouseover', e => {
        const { collection } = e.currentTarget.dataset;
        images.forEach(image => {
          toggle(
            image,
            'active',
            image.classList.contains(`image--${collection}`)
          );
        });

        if (!imageOpen) {
          add(image, 'visible');
        }
      }),

    // Hide image when hover removed
    showImages &&
      listen(collections, 'mouseout', () => {
        remove(images, 'active');
        defaultImage && toggle(defaultImage, 'active', imageOpen);
        toggle(image, 'visible', imageOpen);
      }),

    // Close on escape
    listen(node, 'keydown', ({ keyCode }) => {
      if (keyCode === 27) close();
    }),
  ].filter(Boolean);

  function open(options = {}) {
    add(node, 'active');
    if (options.leftPosition) {
      node.style.left = `${options.leftPosition}px`;
    }
    setTimeout(() => {
      lockbox = lock(node);
      disableBodyScroll(node, { reserveScrollBarGap: true });
      add(node, 'visible');
      node.removeAttribute("hidden");

      showImages && add(defaultImage, 'active');

      // Set focus on first link
      qs('a', node).focus();
    }, 50);
  }

  function close() {
    remove(node, 'visible');
    node.setAttribute("hidden", "");
    setTimeout(() => {
      remove(node, 'active');
      enableBodyScroll(node);
      lockbox();

      events.forEach(evt => evt());
    }, 350);
  }

  return { open, close };
}
